import { PropertyHeaderContent } from 'framework-data-table';
import { useSelector } from 'react-redux';
import { getProperties } from '../../selectors/properties';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyHeader = ({
  columnName
}) => {
  const propertyDefinition = useSelector(getProperties)[columnName];
  return /*#__PURE__*/_jsx(PropertyHeaderContent, {
    propertyDefinition: propertyDefinition
  });
};
export default PropertyHeader;